//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DateTimeField from '../Field/DateTimeField.vue'
import { cardPropertyMixin } from './CardPropertyMixin.js'

export default {
  name: 'CardPropertyDate',
  components: {
    DateTimeField
  },
  mixins: [cardPropertyMixin],
  props: {
    tabProp: {
      type: Object,
      default: null
    },
    object: {
      type: Object,
      default: null
    }
  },
  data: function () {
    let data = {
      placeholder: null
    }

    const config = this.tabProp || this.config || {}
    if (config.componentProps) {
      const componentProps = Object.assign({}, config.componentProps)
      delete componentProps.format
      data = Object.assign(data, componentProps)
    }

    return data
  },
  computed: {
    onlyDate: function () {
      return this.tabProp.type === 'date'
    },
    format: function () {
      const customFormat = this.tabProp && this.tabProp.componentProps && this.tabProp.componentProps.format
      if (customFormat) {
        return customFormat
      }
      if (this.onlyDate) {
        return 'DD.MM.YYYY'
      } else {
        return 'DD.MM.YYYY HH:mm'
      }
    },
    iconTooltip: function () {
      if (this.tabProp.descr && this.tabProp.descr.length) {
        return this.tabProp.descr
      }
      return null
    }
  }
}
